var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"word-cloud-layer"},[_c('word-cloud',{ref:"wordCloud",attrs:{"visible":_vm.TopnavMsg.isShowWordCloudDialog}}),_vm._v(" "),_c('import-text'),_vm._v(" "),_c('text-to-shape'),_vm._v(" "),_c('confirm-cloud')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f124df2c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/WordCloud.vue
// module id = null
// module chunks = 